<nav>
  <ng-content select="ng-container,twaice-fe-side-nav-item,twaice-fe-side-nav-separator"></ng-content>
  <button *ngIf="expandable" class="side-nav__expand" (click)="toggleExpand(state === 'expanded' ? 'collapsed' : 'expanded')">
    <twaice-fe-svg-icon [name]="state === 'expanded' ? 'chevrons-left' : 'chevrons-right'" source="tabler" size="20px" />
  </button>
</nav>
